<template>
    <kgr-generic-select
        ref="dropdown"
        display="name"
        :label="label"
        :options="relationDogs"
        :loading="loading"
        :inline="inline"
        @post-input="onInput"
    />
</template>

<script>
import GenericSelect from './GenericSelect.vue';
import MemberRepository from '../../../../js/repository/MemberRepository.js';

export default {
    components: {
        'kgr-generic-select': GenericSelect,
    },
    props: {
        memberId: {
            type: Number,
            required: true,
        },
        hideLabel: {
            type: Boolean,
            required: false,
            default: false,
        },
        inline: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            loading: true,
            relations: [],
        }
    },
    computed: {
        label() {
            return this.hideLabel ? null : this.$t('club.memberDogRelations');
        },
        relationDogs() {
            return this.relations.map((relation) => relation.dog);
        }
    },
    created() {
        this.reload();
    },
    methods: {
        reload() {
            MemberRepository
                .findDogRelations(this.memberId)
                .then(data => {
                    this.loading = false;
                    this.relations = data;
                })
                .catch(() => this.$notify.error('error.loadingData'));
        },
        onInput(value) {
            this.$emit('input', value);
            this.$nextTick(() => {
                this.$emit('post-input', value);
            });
        }
    }
}
</script>
